<script setup lang="ts">
import type {PageCollectionItemBase} from "@nuxt/content";

const {collectionUri} = useI18nCollection();
const {getIndex, getAllButIndex} = usePage();
const pages: PageCollectionItemBase[] = await queryCollection(collectionUri('about')).all();
const index: PageCollectionItemBase = getIndex(pages)!;
const paragraphs: PageCollectionItemBase[] = getAllButIndex(pages);
</script>

<template>
  <div>
    <NuxtLayout name="page-with-banner" :page="index">
      <SectionArticles :pages="paragraphs" />
    </NuxtLayout>
  </div>
</template>